import { DATE_FORMAT, DAY_FORMAT } from 'consts/dateFormats';
import { AppDatePickerProps } from 'components/atoms';

export const customWeekStartEndFormat: AppDatePickerProps['format'] = (date) => {
    const startPart = date.startOf('week').format(DAY_FORMAT);
    const endPart = date.endOf('week').format(DATE_FORMAT);
    return `${startPart} - ${endPart}`;
};
